import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModulesRoutingModule } from './shared-modules-routing.module';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MaterialModule } from '../material/material-module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { WebPagesComponent } from './web-pages/web-pages.component';
import { RetriveAccountComponent } from './retrive-account/retrive-account.component';
import { ModelComponent } from './model/model/model.component';
import { TwoDigitDecimaNumberDirective } from './two-digit-decima-number.directive';
import { UpperCaseInputDirective } from './uppercase-input.directive';
import { AlphanumericOnlyDirective } from './alpha-numeric.directives';
import { CorporateHeaderComponent } from './corporate-header/corporate-header.component';
import { CorporateHomeComponent } from './corporate-home/corporate-home.component';


@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    OtpVerifyComponent,
    WebPagesComponent,
    RetriveAccountComponent,
    ModelComponent,
    TwoDigitDecimaNumberDirective,
    UpperCaseInputDirective,
    AlphanumericOnlyDirective,
    CorporateHeaderComponent,
    CorporateHomeComponent
  ],
  imports: [
    CommonModule,
    SharedModulesRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SharedModulesModule {}
